<template>
  <div class="seasonal-adjustments">
    <div v-if="noHolidays" class="empty-state">
      <p class="empty-state-text">No seasonal adjustments yet</p>
      <button class="add-adjustment-btn" @click="newAdjustment()">
        Add New Adjustment
      </button>
    </div>

    <div v-else class="adjustments-panel">
      <div class="table-scroll">
        <table class="adjustments-table">
          <thead>
            <tr>
              <th class="col-name">Name</th>
              <th class="col-date">Start Date</th>
              <th class="col-date">End Date</th>
              <th class="col-type">Type</th>
              <th class="col-amount">Amount</th>
              <th class="col-actions" />
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(holiday, uuid) in all_holidays"
              :key="uuid"
              :class="{ 'row-alt': uuid % 2 !== 0 }"
            >
              <td class="col-name">
                <span class="adjustment-name">{{ holiday.name }}</span>
              </td>
              <td class="col-date">
                <span class="date-text">{{ holiday.start_date }}</span>
              </td>
              <td class="col-date">
                <span class="date-text">{{ holiday.end_date }}</span>
              </td>
              <td class="col-type">
                <span
                  class="type-badge"
                  :class="
                    holiday.type === 'Increase'
                      ? 'type-increase'
                      : 'type-decrease'
                  "
                >
                  {{ holiday.type }}
                </span>
              </td>
              <td class="col-amount">
                <span class="amount-badge">
                  <template v-if="holiday.select === 'Amount'">
                    ${{ holiday.quantity }}
                  </template>
                  <template v-else>{{ holiday.quantity }}%</template>
                </span>
              </td>
              <td class="col-actions">
                <div class="row-actions">
                  <button
                    class="action-btn"
                    title="Edit"
                    @click="updateAdjustment(holiday)"
                  >
                    <img src="../../assets/editIcon.svg" alt="Edit" />
                  </button>
                  <button
                    class="action-btn"
                    title="Delete"
                    @click="showDeletePopupAction(true, holiday.uuid)"
                  >
                    <img src="../../assets/deleteIcon.svg" alt="Delete" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="panel-footer">
        <button class="add-adjustment-btn" @click="newAdjustment()">
          Add New Adjustment
        </button>
      </div>
    </div>

    <new-adjustment-popup
      :adjustments="adjustments"
      v-if="adjustmentPopupCreate"
      @close="closeCreate()"
      @ok="doCreate"
    />
    <edit-adjustment-popup
      :adjustments="adjustments"
      :data="updateData"
      v-if="adjustmentPopupUpdate"
      @close="closeUpdate()"
      @ok="doUpdate"
    />

    <div class="save-notice">
      <img src="../../assets/error_red.png" alt="" />
      <span>Changes will not be saved until the room has been saved</span>
    </div>

    <div v-if="showDeletePopup">
      <delete-popup
        @confirm="doDelete"
        @cancel="showDeletePopupAction(false, null)"
        :thingName="'Seasonal Adjustment'"
      />
    </div>
  </div>
</template>
<script>
import NewAdjustmentPopup from './NewAdjustmentPopup.vue'
import EditAdjustmentPopup from './EditAdjustmentPopup.vue'
import DeletePopup from '../../components/GenericDeletePopup.vue'

export default {
  name: 'SeasonalAdjustmentsList',
  data() {
    return {
      all_holidays: [],
      adjustmentPopupCreate: false,
      adjustmentPopupUpdate: false,
      showDeletePopup: false,
      holidayID: null
    }
  },
  components: {
    NewAdjustmentPopup,
    EditAdjustmentPopup,
    DeletePopup
  },
  computed: {
    noHolidays() {
      return (
        this.all_holidays == null ||
        this.all_holidays == undefined ||
        this.all_holidays.length == 0
      )
    }
  },
  methods: {
    newAdjustment() {
      this.adjustmentPopupCreate = true
    },
    closeCreate() {
      this.adjustmentPopupCreate = false
    },
    doCreate(payload) {
      this.adjustmentPopupCreate = false

      let startDate = new Date(payload.rangeDate[0]).toLocaleDateString('en-US')
      let endDate = new Date(payload.rangeDate[1]).toLocaleDateString('en-US')

      const adjust = {
        uuid: 'create-' + Math.floor(Math.random() * 90000) + 10000,
        name: payload.name,
        start_date: startDate,
        end_date: endDate,
        type: payload.type,
        quantity: payload.quantity,
        select: payload.selectedType
      }

      this.all_holidays.push(adjust)

      this.$emit('createGraph', adjust)
    },
    loadAdjustments() {
      for (let i = 0; i < this.adjustments.length; i++) {
        const holiday = this.adjustments[i]
        this.all_holidays.push({
          uuid: holiday.uuid,
          name: holiday.name,
          start_date: holiday.startDate,
          end_date: holiday.endDate,
          type: holiday.type,
          quantity: holiday.quantity,
          select: holiday.select
        })
      }
    },
    updateAdjustment(holiday) {
      this.updateData = holiday
      this.adjustmentPopupUpdate = true
    },
    closeUpdate() {
      this.adjustmentPopupUpdate = false
    },
    doUpdate(payload) {
      this.adjustmentPopupUpdate = false

      let startDate = new Date(payload.rangeDate[0]).toLocaleDateString('en-US')
      let endDate = new Date(payload.rangeDate[1]).toLocaleDateString('en-US')

      const adjust = {
        uuid: payload.uuid,
        name: payload.name,
        start_date: startDate,
        end_date: endDate,
        type: payload.type,
        quantity: payload.quantity,
        select: payload.selectedType
      }

      for (let i = 0; i < this.all_holidays.length; i++) {
        if (this.all_holidays[i].uuid === payload.uuid) {
          this.all_holidays[i].name = payload.name
          this.all_holidays[i].start_date = startDate
          this.all_holidays[i].end_date = endDate
          this.all_holidays[i].type = payload.type
          this.all_holidays[i].quantity = payload.quantity
          this.all_holidays[i].select = payload.selectedType
          break
        }
      }

      this.$emit('editGraph', adjust)
    },
    async showDeletePopupAction(value, holidayID) {
      this.showDeletePopup = value
      this.holidayID = holidayID
    },
    async doDelete() {
      this.$emit('deleteGraph', this.holidayID)

      for (let i = 0; i < this.all_holidays.length; i++) {
        if (this.all_holidays[i].uuid === this.holidayID) {
          this.all_holidays.splice(i, 1)
          break
        }
      }

      this.holidayID = null
      this.showDeletePopup = false
    }
  },
  props: {
    adjustments: {
      type: Array
    }
  },
  created() {
    this.loadAdjustments()
  }
}
</script>

<style scoped>
.seasonal-adjustments {
  width: 100%;
  font-family: Montserrat, sans-serif;
}

/* ── Empty state ─────────────────────────────────────────── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 28px 20px;
  border: 1px dashed #cbd4dc;
  border-radius: 8px;
  background: #fafbfc;
}

.empty-state-text {
  margin: 0;
  font-size: 13px;
  color: #767675;
  font-weight: 500;
}

/* ── Panel ───────────────────────────────────────────────── */
.adjustments-panel {
  border: 1px solid #e8ecef;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.table-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* ── Table ───────────────────────────────────────────────── */
.adjustments-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.adjustments-table thead th {
  padding: 11px 14px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #66b015;
  background: #ebf0e6;
  border-bottom: 1px solid #d8e4cc;
  text-align: left;
  white-space: nowrap;
}

.adjustments-table tbody td {
  padding: 12px 14px;
  font-size: 12px;
  line-height: 1.4;
  color: #192a3e;
  vertical-align: middle;
}

.adjustments-table tbody tr {
  transition: background-color 0.12s ease;
}

.adjustments-table tbody tr.row-alt {
  background-color: #fafbfc;
}

.adjustments-table tbody tr:hover {
  background-color: #f4fae8 !important;
}

.adjustments-table tbody tr:not(:last-child) td {
  border-bottom: 1px solid #f0f2f4;
}

/* ── Column sizing ───────────────────────────────────────── */
.col-name {
  width: 26%;
  text-align: left;
}

.col-date {
  width: 17%;
  text-align: left;
}

.col-type {
  width: 14%;
  text-align: left;
}

.col-amount {
  width: 14%;
  text-align: left;
}

.col-actions {
  width: 12%;
  text-align: center;
}

/* ── Cell content ────────────────────────────────────────── */
.adjustment-name {
  display: block;
  font-weight: 500;
  color: #2c3e50;
  white-space: normal;
  word-break: break-word;
  line-height: 1.35;
  max-height: 2.7em;
  overflow: hidden;
}

.date-text {
  color: #4a4a4a;
  font-size: 12px;
  white-space: nowrap;
}

.type-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.type-increase {
  background: #e8f5d5;
  color: #3a6409;
}

.type-decrease {
  background: #fdf2f3;
  color: #c0392b;
}

.amount-badge {
  display: inline-block;
  min-width: 48px;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  background: #f0f2f4;
  color: #2c3e50;
}

/* ── Row actions ─────────────────────────────────────────── */
.row-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  transition: background-color 0.12s ease;
}

.action-btn:hover {
  background: rgba(102, 176, 21, 0.12);
}

.action-btn img {
  width: 14px;
  height: 14px;
}

/* ── Footer / add button ─────────────────────────────────── */
.panel-footer {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  border-top: 1px solid #f0f2f4;
  background: #fafbfc;
}

.add-adjustment-btn {
  color: #fff;
  background-color: #66b015;
  height: 36px;
  padding: 0 18px;
  border: none;
  border-radius: 5px;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.12s ease;
}

.add-adjustment-btn:hover {
  background-color: #5a9d12;
}

/* ── Save notice ─────────────────────────────────────────── */
.save-notice {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
  padding: 10px 14px;
  width: 100%;
  box-sizing: border-box;
  color: #df000e;
  background: #fdf2f3;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
}

.save-notice img {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

/* ── Mobile ──────────────────────────────────────────────── */
@media (max-width: 768px) {
  .adjustments-table {
    min-width: 560px;
  }

  .adjustments-table thead th,
  .adjustments-table tbody td {
    padding: 10px 12px;
    font-size: 11px;
  }

  .panel-footer {
    padding: 10px 12px;
  }

  .add-adjustment-btn {
    width: 100%;
    height: 40px;
    font-size: 13px;
  }

  .empty-state {
    padding: 24px 16px;
  }

  .empty-state .add-adjustment-btn {
    width: 100%;
    height: 40px;
  }
}
</style>
